import { Code2, FileSearch, FileText, FileType, Notebook, Table2 } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface FormatCard {
  id: "csv" | "pdf" | "text-md" | "html" | "docx" | "enex";
  label: string;
  description: string;
  icon: LucideIcon;
  iconBg: string;
  iconColor: string;
  accept: string;
}

export const FORMAT_CARDS: readonly FormatCard[] = [
  {
    id: "csv",
    label: "CSV",
    description: "Import structured data from spreadsheets",
    icon: Table2,
    iconBg: "bg-emerald-50 dark:bg-emerald-950/30",
    iconColor: "text-emerald-600 dark:text-emerald-400",
    accept: ".csv",
  },
  {
    id: "pdf",
    label: "PDF",
    description: "Extract content from PDF documents",
    icon: FileSearch,
    iconBg: "bg-red-50 dark:bg-red-950/30",
    iconColor: "text-red-500 dark:text-red-400",
    accept: ".pdf",
  },
  {
    id: "text-md",
    label: "Text & Markdown",
    description: "Import plain text and formatted notes",
    icon: FileText,
    iconBg: "bg-blue-50 dark:bg-blue-950/30",
    iconColor: "text-blue-500 dark:text-blue-500",
    accept: ".txt,.md",
  },
  {
    id: "docx",
    label: "Word",
    description: "Import Word documents with formatting",
    icon: FileType,
    iconBg: "bg-indigo-50 dark:bg-indigo-950/30",
    iconColor: "text-indigo-500 dark:text-indigo-400",
    accept: ".docx",
  },
  {
    id: "enex",
    label: "Evernote",
    description: "Import notebooks exported as .enex",
    icon: Notebook,
    iconBg: "bg-teal-50 dark:bg-teal-950/30",
    iconColor: "text-teal-600 dark:text-teal-400",
    accept: ".enex",
  },
  {
    id: "html",
    label: "HTML",
    description: "Import web pages and structured content",
    icon: Code2,
    iconBg: "bg-orange-50 dark:bg-orange-950/30",
    iconColor: "text-orange-500 dark:text-orange-400",
    accept: ".html,.htm",
  },
] as const;
